export const getSidebarStyles = (theme, type, drawerWidth) => {
    const marginType = `margin${type.charAt(0).toUpperCase() + type.slice(1)}`;
    return {
        drawer: {
            width: drawerWidth,
            [theme.breakpoints.down('xs')]: {
                width: 300,
            },
            flexShrink: 0,
            position: 'fixed',
            [type]: 0,
            zIndex: 10
        },
        paper: {
            overflow: 'hidden',
            zIndex: 2,
            boxShadow: type === 'right' ? '-3px 0px 6px #00000029' : '3px 0px 6px #00000029',
            left: 'inherit'
        },
        drawerOpen: {
            width: drawerWidth,
            [theme.breakpoints.down('xs')]: {
                width: 300,
            },
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: 0
        },
        collapseButton: {
            position: 'fixed',
            zIndex: 20,
            background: 'white',
            boxShadow: type === 'right' ? '-10px 0px 9px -5px #00000029' : '10px 0px 9px -5px #00000029',
            top: 45,
            width: 50,
            height: 50,
            display: "flex",
            justifyContent: type === 'right' ? 'left' : 'right',
            padding: type === 'right' ? "6px 6px 6px 14px" : "6px 14px 6px 6px",
            transition: theme.transitions.create(type, {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            '&:hover': {
                background: 'white'
            }
        },
        collapseButtonClose: {
            [type]: -60
        },
        collapseButtonOpen: {
            [type]: 420,
            [theme.breakpoints.down('xs')]: {
                [type]: 265,
            },
        },
        imgMain: {
            width: 50,
            height: 40,
            padding: '28px 0px'
        },
        listItemClose: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        listItemOpen: {
            [marginType]: 40
        },
        text: {
            textTransform: 'capitalize'
        }
    }
}